<template>
  <section id="home">
    <div class="hero-grid-lines"></div>
    <div class="hero-left">
      <div class="hero-eyebrow">
        <span class="badge">EN54</span>
        <span class="badge">VdS</span>
        <span class="badge">Grade 3</span>
      </div>
      <h1>{{ m.hero.titleLine1 }}<br><em>{{ m.hero.titleLine2 }}<br>{{ m.hero.titleLine3 }}</em></h1>
      <p class="hero-sub">{{ m.hero.subtitle }}</p>
      <a href="#contact" class="btn-primary" @click.prevent="scrollToContact">{{ m.hero.cta }}</a>
    </div>
    <div class="hero-right">
      <img src="/img/splash.jpg" :alt="m.hero.imageAlt">
    </div>
  </section>

  <div class="stats-strip">
    <div class="stat reveal">
      <span class="stat-num">50+</span>
      <div class="stat-label">{{ m.hero.stats.projects }}</div>
    </div>
    <div class="stat reveal" style="transition-delay:.1s">
      <span class="stat-num">100%</span>
      <div class="stat-label">{{ m.hero.stats.standards }}</div>
    </div>
    <div class="stat reveal" style="transition-delay:.2s">
      <span class="stat-num">20+</span>
      <div class="stat-label">{{ m.hero.stats.expertise }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SECTION_HREF } from '~/constants/sections'

const { messages: m } = useI18n()
const { scrollToSection } = useSmoothScroll()
const { setActiveSection } = useActiveSection()

const scrollToContact = () => {
  setActiveSection(SECTION_HREF.contact)
  scrollToSection(SECTION_HREF.contact)
}
</script>